import { Box, styled } from "@mui/material";
import { DiscoverCardActionArea } from "./discover-card-action-area";
import { MomentContent } from "./discover-card-content";
import { MomentImage } from "./discover-card-image";

import type { BrandInfoSelected } from "../../brand-kit/types";
import type { DiscoverTemplate } from "../types";
import type { CardProps } from "@mui/material";
import type { FC, ReactNode } from "react";

interface DiscoverTemplateCardProps extends Omit<CardProps, "onClick"> {
  template: DiscoverTemplate;
  onClick?: (e: React.MouseEvent<HTMLDivElement>, template: DiscoverTemplate) => void;
  brandKitSelections?: BrandInfoSelected;
  badge?: ReactNode;
  subheadingGetter?: (t: DiscoverTemplate) => string | null;
}

const CardContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  flexGrow: 1,
  width: "100%",
  transition: "padding .3s ease-in-out",
  className: "Card-content",
}));

export const DiscoverCard: FC<DiscoverTemplateCardProps> = ({
  template,
  onClick,
  brandKitSelections,
  badge,
  subheadingGetter,
  ...boxProps
}) => {
  const handleClick = (e: React.MouseEvent<HTMLDivElement>): void => {
    onClick?.(e, template);
  };

  return (
    <Box
      {...boxProps}
      onClick={handleClick}
      sx={{
        maxWidth: "320px",
        overflow: "visible",
        ...boxProps?.sx,
      }}
    >
      <DiscoverCardActionArea>
        <Box sx={{ position: "relative", width: "100%", paddingBottom: "100%", flexGrow: 0 }}>
          {badge}
          <MomentImage template={template} brandKitSelections={brandKitSelections} />
        </Box>
        <CardContent className="Card-content">
          <MomentContent template={template} subheadingGetter={subheadingGetter} />
        </CardContent>
      </DiscoverCardActionArea>
    </Box>
  );
};
